<template>
  <HeaderBlock />
  <section class="title_catalog_container">
    <div class="title_goods_block">
      <img
        class="back_header_img1"
        src="@/assets/img/jijki6back/cola_lemon.jpg"
        alt=""
      />

      <div class="header_text_container_goods_img_pos">
        <div class="header_text_container_goods">
          <p class="title_goods_name header_text_container_goods_img_pos_phone">
            кола <br />
            <span class="goods_name_margin title_goods_name">лимон</span>
          </p>
          <div class="title_goods_list_container_block">
            <div class="title_goods_list_text_block">
              <div class="title_goods_list_container">
                <div class="title_goods_list">
                  <p class="title_goods_list_text">материал</p>
                  <hr />
                </div>
                <p class="title_goods_list_text">пластик</p>
              </div>
            </div>
            <div class="title_goods_list_container">
              <div class="title_goods_list">
                <p class="title_goods_list_text">Крепость</p>
                <hr />
              </div>
              <p class="title_goods_list_text title_goods_list_text_phone1">
                hard
              </p>
              <p class="title_goods_list_text title_goods_list_text_phone">
                алюм, сплав, пластик
              </p>
            </div>
            <div class="title_goods_list_container">
              <div class="title_goods_list">
                <p class="title_goods_list_text">баланс</p>
                <hr />
              </div>
              <p class="title_goods_list_text">50/50</p>
            </div>
            <div class="title_goods_list_container">
              <div class="title_goods_list">
                <p class="title_goods_list_text">объем</p>
                <hr />
              </div>
              <p class="title_goods_list_text">30 мл</p>
            </div>
            <div class="title_goods_list_container">
              <div class="title_goods_list">
                <p class="title_goods_list_text">крепость</p>
                <hr />
              </div>
              <p class="title_goods_list_text">50 мг</p>
            </div>
          </div>
          <div
            class="list_product_dots list_product_dots_goods list_product_dots_pos_goods"
          >
            <span>30 ml</span>
            <span>20 mg</span>
            <span>salt</span>
          </div>
        </div>
        <div class="header_goods_img_block header_goods_img_block1">
          <img
            class="header_goods_img1"
            src="@/assets/img/jijki6/cola_lemon2.png"
            alt=""
          />
        </div>
        <p class="title_goods_name title_article_list_text_phone12">
          кола <br />
          <span
            class="goods_name_margin title_goods_name title_article_list_text_phone12"
            >лимон</span
          >
        </p>
      </div>
      <SocialMediaGoods />
    </div>
  </section>
  <div class="day_night_container">
    <div class="day_night_block">
      <div class="day_night_text_block">
        <p class="day_night_title">day&night</p>
        <p class="day_night_text">линейка вкусов<br />для ценителей крепости</p>
      </div>
      <div class="day_night_img_block">
        <div class="day_night_img">
          <img
            class="day_night_img1"
            src="@/assets/img/day_night1.png"
            alt=""
          />
          <p class="day_night_text_img color_white">
            Более высокая<br />усвояемость<br />никотина
          </p>
        </div>
        <div class="day_night_img">
          <img
            class="day_night_img1"
            src="@/assets/img/day_night2.png"
            alt=""
          />
          <p class="day_night_text_img color_white">Отличное<br />насыщение</p>
        </div>
        <div class="day_night_img">
          <img
            class="day_night_img1"
            src="@/assets/img/day_night3.png"
            alt=""
          />
          <p class="day_night_text_img color_white">
            Инновационный<br />подход
          </p>
        </div>
      </div>
    </div>
  </div>
  <section class="top_goods_slider">
    <div class="top_goods_block">
      <p class="top_tastes_text color_grey-black">популярные товары</p>
      <GoodsSlider />
    </div>
  </section>
  <TopLiest />
  <MakeorderBlock />
  <FooterBlock />
</template>

<script>
import HeaderBlock from "@/components/stabl/HeaderBlock.vue";
import MakeorderBlock from "@/components/stabl/MakeorderBlock.vue";
import FooterBlock from "@/components/stabl/FooterBlock.vue";
import TopLiest from "@/components/stabl/TopLiest.vue";
import GoodsSlider from "@/components/UI/GoodsSlider.vue";
import SocialMediaGoods from "@/components/UI/SocialMediaGoods.vue";
export default {
  components: {
    HeaderBlock,
    MakeorderBlock,
    FooterBlock,
    TopLiest,
    GoodsSlider,
    SocialMediaGoods,
  },
};
</script>
